import React from 'react';
import PropTypes from 'prop-types';

const ForgeStack = ({
  inline = false,
  wrap = false,
  stretch = false,
  alignment = 'start',         // 'start' | 'center' | 'end'
  justify = 'start',       // 'start' | 'center' | 'end' | 'space-between'
  gap = '16',
  children,
  className = '',
  style = {},
  ...props
}) => {
  const combinedClassName = [
    'forge-stack',
    inline && 'forge-stack--inline',
    wrap && 'forge-stack--wrap',
    stretch && 'forge-stack--stretch',
    alignment && `forge-stack--align-${alignment}`,
    justify && `forge-stack--justify-${justify}`,
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={combinedClassName}
      {...props}
      style={{ gap: `${gap}px`, ...style }}
    >
      {children}
    </div>
  );
};

ForgeStack.propTypes = {
  inline: PropTypes.bool,
  wrap: PropTypes.bool,
  stretch: PropTypes.bool,
  alignment: PropTypes.oneOf(['start', 'center', 'end']),
  justify: PropTypes.oneOf(['start', 'center', 'end', 'space-between']),
  gap: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};

export default ForgeStack;

// forge-stack	------------ The base stack container class.
// forge-stack--inline	----------- Renders the stack in the inline (horizontal) direction.
// forge-stack--wrap	----------- Allows the stack to wrap to a new line in inline mode.
// forge-stack--stretch	--------- Stretches the children to take up the maximum amount of space.
// forge-stack--align-start	-------- Aligns the children to the start of the stack.
// forge-stack--align-center	--------- Aligns the children to the center of the stack.
// forge-stack--align-end	---------- Aligns the children to the end of the stack.
// forge-stack--justify-start	--------- Justifies the children to the start of the stack.
// forge-stack--justify-center	----------- Justifies the children to the center of the stack.
// forge-stack--justify-end	--------- Justifies the children to the end of the stack.
// forge-stack--justify-space-between	--------- Justifies the children with equal space between them.
